export default __webpack_public_path__ + "static/media/PowerAI-270x145-logo.d6cdf89f.svg";